import classNames from 'classnames';

const Minus = ({ className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('icon', className)}
  >
    <title>Minus</title>
    <g fillRule="evenodd">
      <path
        fill="currentColor"
        d="M4.9999997,12.9999993 L18.9999997,12.9999993 C19.5522844,12.9999993 19.9999997,12.552284 19.9999997,11.9999993 C19.9999997,11.4477145 19.5522844,10.9999993 18.9999997,10.9999993 L4.9999997,10.9999993 C4.44771495,10.9999993 3.9999997,11.4477145 3.9999997,11.9999993 C3.9999997,12.552284 4.44771495,12.9999993 4.9999997,12.9999993 Z"
      />
    </g>
  </svg>
);

Minus.propTypes = {
  className: PropTypes.string,
};

export default Minus;
